import { Component, OnInit, OnDestroy } from '@angular/core';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SessionService } from 'app/store/services/session.service';
import { IUserSessionData, FLASH_TYPE } from 'app/store/models/user.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UtilitiesService } from 'app/store/services/utilities.servive';
import { ISelectItem } from 'app/store/models/select.model';
import { UserService } from 'app/store/services/user.service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IReducers } from 'app/store/reducers';
import { setFlash, updateTimezone } from 'app/store/actions/user.action';
import { openSnackbar } from '../../store/actions/page.action';

@Component({
  selector: 'app-change-timezone',
  templateUrl: './change-timezone.component.html',
  styleUrls: ['./change-timezone.component.scss'],
})
export class ChangeTimezoneComponent implements OnInit, OnDestroy {
  formGroup: FormGroup;

  sessionData: IUserSessionData;

  timezones: ISelectItem[];

  cancelButtonProperties: Button = {
    text: 'Cancel',
    color: ButtonColor.RED,
    size: ButtonSize.NORMAL,
    route: ['/accounts', 'settings'],
    style: 'outline',
  };

  continueButtonProperties: Button = {
    text: 'Update',
    color: ButtonColor.BLUE,
    size: ButtonSize.NORMAL,
    onClick: () => this.submitForm(),
    style: 'filled',
  };

  private destroy$: Subject<boolean> = new Subject<boolean>();

  submitForm() {
    if (this.formGroup.valid) {
      this.userService
        .updateUserTimezone(
          this.sessionData.id,
          this.formGroup.get('timezone').value,
          this.formGroup.get('observe_dst').value
        )
        .subscribe(res => {
          this.store.dispatch(
            updateTimezone({
              timezone: this.formGroup.get('timezone').value,
            })
          );
          this.store.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  type: 'success',
                  message: 'Your timezone was updated',
                },
                verticalPosition: 'bottom',
              },
            })
          );
          this.router.navigate(['/']);
        });
    } else {
      this.formGroup.markAllAsTouched();
    }
  }

  constructor(
    private sessionService: SessionService,
    private utilService: UtilitiesService,
    private userService: UserService,
    private router: Router,
    private store: Store<IReducers>
  ) {}

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(sessionData => {
        this.sessionData = sessionData;

        this.timezones = this.utilService.getTimezones('ALL').map(timezone => {
          return {
            label: timezone,
            value: timezone,
          };
        });

        this.formGroup = new FormGroup({
          timezone: new FormControl(this.sessionData.time_zone, [
            Validators.required,
          ]),
          observe_dst: new FormControl(this.sessionData.dst),
        });
      });
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }
}
